"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OlapicWidget = void 0;
var _i18n = require("@ori/i18n");
var _logger = require("@ori/logger");
var _testidGenerator = require("@ori/testid-generator");
var _react = require("react");
var _constantsGenerated = require("./constants-generated");
var _defaultTranslations = require("./constants/defaultTranslations");
var _containers = require("./containers");
var _contexts = require("./contexts");
var _collapseContext = require("./contexts/collapseContext");
var _logger2 = require("./logger");
var _jsxRuntime = require("react/jsx-runtime");
/* istanbul ignore file @preserve --container */

const localLogger = _logger2.mainLogger.createChild('OlapicWidget');
const OlapicWidget = props => {
  const {
    type
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.ConfigurationProvider, {
    value: props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
      fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_containers.WidgetSkeletonWrapper, {
        type: type
      }),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
        logger: localLogger,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_testidGenerator.TestIdProvider, {
          team: _testidGenerator.Team.Presentation,
          project: _constantsGenerated.APP_NAME,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_containers.ApiProvider, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_collapseContext.CollapseProvider, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
                namespace: _defaultTranslations.translationsNamespace,
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_containers.Widget, {})
              })
            })
          })
        })
      })
    })
  });
};
exports.OlapicWidget = OlapicWidget;
